<div class="wrapper">
  <div class="container">
    @if (sections.length > 0) {
      <div class="section">
        <div class="page-header">
          <h2 class="heading">初期選択スキルマップ</h2>
        </div>
        <div class="checkbox-wrapper">
          @for (target of sections; track target) {
            <div class="default-skill-map-setting">
              <div class="setting-label">{{ labels[target] }}</div>
              <p class="caption">{{ descriptions[target] }}</p>
              <app-select
                [ariaLabel]="labels[target] + 'の初期選択スキルマップ'"
                [options]="options"
                [selectedOption]="selectedOptions[target] ?? unsetOption"
                [disabled]="saving || loading"
                (selectedOptionChange)="onSelectionChange(target, $event)"
              />
            </div>
          }
        </div>
      </div>
    }
    @if (isSuperAdmin) {
      <app-role-model-recommendation-setting />
    }
  </div>
</div>
